export default "__VITE_ASSET__7Cw5Vx_I__"